import { createContext } from 'react';
import { Property } from '../types';

export interface PropertiesContextType {
  properties: Property[];
  loading: boolean;
  error: string | null;
  addProperty: (property: Omit<Property, 'id' | 'createdAt' | 'updatedAt'>) => Promise<void>;
  removeProperty: (propertyId: string) => Promise<void>;
  updateProperty: (propertyId: string, propertyData: Partial<Omit<Property, 'id'>>) => Promise<void>;
}

export const PropertiesContext = createContext<PropertiesContextType | undefined>(undefined);
